const getters = {
  getIsOptimizing: (state) => (state.isOptimizing),
  getIsSaving: (state) => (state.isSaving),
  getOptimizedDrops: (state) => (state.optimizedDrops),
  getIsReadyToBeSaved: (state) => (state.isReadyToBeSaved)
}
export default getters
